import Vue from 'vue'
import { mapState } from 'vuex'
import permissionsHandler from '@/utils/permissionsHandler'

Vue.mixin({
  computed: {
    ...mapState('app', ['me'])
  },
  methods: {
    $handleApiError (gqlErrors = [], ctxI18n = null) {
      gqlErrors.forEach(gqlError => {
        const code = gqlError.extensions?.exception?.code?.src
        this.$errorMsg(this.$t(`apiMessages.${ctxI18n}.${code}`))
      })
    },
    $reloadMe () {
      this.$eh.$emit('update-me')
    },
    $successMsg (text) {
      this.$eh.$emit('snackbar', { color: 'success', text })
    },
    $errorMsg (text) {
      this.$eh.$emit('snackbar', { color: 'error', text })
    },
    $permissionsHandler (permissions = []) {
      const permissionsListKeys = this.me.permissions.map(p => p.key)
      return permissionsHandler(permissionsListKeys, permissions)
    }
  }
})
